if (!customElements.get('crowdfund-progress')) {
  customElements.define(
    'crowdfund-progress',
    class CrowdfundProgress extends HTMLElement {
      connectedCallback() {
        this._onEditionChanged = this._handleEditionChanged.bind(this);
        document.addEventListener('t18:edition-changed', this._onEditionChanged);
        this._initAmounts();
        this._startTimer();
      }

      disconnectedCallback() {
        document.removeEventListener('t18:edition-changed', this._onEditionChanged);
        if (this._timerInterval) clearInterval(this._timerInterval);
      }

      _initAmounts() {
        // Post-goal state: format earnings cents into dollar strings
        this.querySelectorAll('[data-cents]').forEach((el) => {
          const dollars = parseInt(el.dataset.cents, 10) / 100;
          el.textContent =
            '$' +
            dollars.toLocaleString('en-US', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            });
        });
      }

      _startTimer() {
        const timerEl = this.querySelector('.t18-crowdfund__timer');
        if (!timerEl) return;

        const endDate = new Date(timerEl.dataset.endDate);
        if (isNaN(endDate.getTime())) return;

        const daysEl = timerEl.querySelector('[data-timer-days]');
        const hoursEl = timerEl.querySelector('[data-timer-hours]');
        const minutesEl = timerEl.querySelector('[data-timer-minutes]');
        const secondsEl = timerEl.querySelector('[data-timer-seconds]');

        const tick = () => {
          const diff = endDate - Date.now();

          if (diff <= 0) {
            clearInterval(this._timerInterval);
            if (daysEl) daysEl.textContent = '00';
            if (hoursEl) hoursEl.textContent = '00';
            if (minutesEl) minutesEl.textContent = '00';
            if (secondsEl) secondsEl.textContent = '00';
            timerEl.classList.add('t18-crowdfund__timer--expired');
            return;
          }

          const d = Math.floor(diff / 864e5);
          const h = Math.floor((diff % 864e5) / 36e5);
          const m = Math.floor((diff % 36e5) / 6e4);
          const s = Math.floor((diff % 6e4) / 1e3);

          if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
          if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
          if (minutesEl) minutesEl.textContent = String(m).padStart(2, '0');
          if (secondsEl) secondsEl.textContent = String(s).padStart(2, '0');
        };

        tick();
        this._timerInterval = setInterval(tick, 1000);
      }

      _handleEditionChanged({ detail: { type, copies } }) {
        this._updateGhostFill(copies);
        this._updateImpactLine(type);
      }

      _updateGhostFill(copies) {
        const ghost = this.querySelector('.t18-crowdfund__ghost-fill');
        if (!ghost) return;

        const basePct = parseFloat(ghost.dataset.basePct);
        const goal = parseInt(this.dataset.goal, 10);
        const ghostPct = Math.min(100, basePct + (copies / goal) * 100);

        ghost.style.width = ghostPct + '%';
        ghost.classList.add('t18-crowdfund__ghost-fill--visible');
      }

      _updateImpactLine(type) {
        const el = this.querySelector('.t18-crowdfund__impact-line');
        if (!el) return;

        const template =
          type === 'premium' ? el.dataset.messagePremium : el.dataset.messageStandard;
        if (!template) return;

        const copies =
          type === 'premium'
            ? el.dataset.premCopies || '5'
            : el.dataset.stdCopies || '1';
        const amount = type === 'premium' ? el.dataset.premAmount : el.dataset.stdAmount;
        const restaurant = el.dataset.restaurant || 'this restaurant';

        el.textContent = template
          .replace('{copies}', copies)
          .replace('{amount}', amount || '')
          .replace('{restaurant}', restaurant);

        el.classList.toggle('t18-crowdfund__impact-line--premium', type === 'premium');
      }
    }
  );
}
